export default __webpack_public_path__ + "static/media/single_user.08281bf8.svg";